import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faYoutube,
  faTwitch
} from '@fortawesome/free-brands-svg-icons';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import HpTooltip from '../../../../components/shared/components/hpTooltip';
import TextField from '@material-ui/core/TextField';
import { contentTypes } from '../../../../constants';

const styles = theme => ({
  socialSelection: {
    width: ' 150px',
    margin: '10px',
    cursor: 'pointer'
  },
  item: {
    color: 'black'
  },
  itemSelected: {
    color: '#5DBE76'
  },
  button: {
    color: 'gray',
    backgroundColor: 'white',
    borderColor: 'gray',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  youtubeButton: {
    color: 'gray',
    backgroundColor: 'white',
    borderColor: 'gray',
    borderStyle: 'solid',
    borderWidth: '1px',
    '&:hover': {
      backgroundColor: '#5DBE76',
      color: 'white'
    }
  },
  buttonSelected: {
    color: 'white',
    // color: 'red',
    backgroundColor: '#5DBE76',
    border: 'none',
    '&:hover': {
      backgroundColor: '#5DBE76',
      color: 'white'
    }
  },
  icon: {
    width: '50px!important',
    height: '50px!important'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  },
  platformContainer: {
    alignItems: 'flex-start'
  },
  sectionTitle: {
    marginBottom: '20px'
  },
  contentTypeTitle: {
    marginTop: '50px',
    marginBottom: '40px'
  },
  radioGroup: {
    width: '100%'
  },
  radioGridContainer: {
    width: '100%',
    maxWidth: '700px',
    alignSelf: 'center'
  },
  comingSoon: {
    fontSize: '.8em'
  },
  contentTypeContainer: {
    marginBottom: '30px'
  },
  contentTypeButton: {
    width: '70%',
    height: '50px',
    borderColor: '#5DBE76',
    borderStyle: 'solid',
    borderWidth: '1px',
    '&:hover': {
      backgroundColor: '#5DBE76'
    }
  },
  selectedContentType: {
    backgroundColor: '#5DBE76',
    color: 'white'
  },
  inputError: {
    color: '#ffbb44',
    fontSize: '.8em'
  }
});

const StyledButton = withStyles({
  root: {
    borderRadius: '5px',
    height: '120px',
    width: '120px',
    padding: '0px',
    marginBottom: '10px'
  }
})(IconButton);

class CreatePlatform extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedButton: null,
      platformError: '',
      contentTypeError: '',
      otherContentTypeError: '',
      nextAttempted: false
    };
  }

  changePlatformClick = e => {
    this.setState({
      selectedButton: 'youtube'
    });
  };

  contentTypeError = () => {
    return !this.props.campaignInfo.contentType;
  };

  platformError = () => {
    return !this.state.selectedButton;
  };

  otherContentTypeError = () => {
    return (
      this.props.campaignInfo.contentType === contentTypes.OTHER &&
      !this.props.campaignInfo.otherContentDetails
    );
  };

  nextButtonClickHandler = () => {
    this.setState({
      nextAttempted: true
    });
    if (this.platformError()) {
      this.setState({
        platformError: 'platform is required'
      });
    }
    if (this.contentTypeError()) {
      this.setState({
        contentTypeError: 'content type is required'
      });
    }
    if (this.otherContentTypeError()) {
      this.setState({
        otherContentTypeError:
          'description of content is required when "other" is selected'
      });
    }
    if (!this.platformError() && !this.contentTypeError()) {
      this.props.nextButtonClick();
    }
  };

  render() {
    const {
      classes,
      campaignInfo,
      changeContentType,
      changeOtherContentDescription
    } = this.props;
    const { selectedButton } = this.state;

    return (
      <React.Fragment>
        <div className={classes.sectionTitle}>
          <Typography variant="h6" justify="center" align="center">
            Choose your platform
          </Typography>
          {this.state.nextAttempted && this.state.platformError && (
            <Typography align="center" className={classes.inputError}>
              platform selection is required
            </Typography>
          )}
        </div>
        <Grid
          container
          direction="row"
          spacing={24}
          justify="center"
          className={classes.platformContainer}
        >
          <Grid
            container
            align="center"
            justify="center"
            direction="column"
            className={classes.socialSelection}
          >
            <StyledButton
              name="youtube"
              className={
                selectedButton === 'youtube'
                  ? classes.buttonSelected
                  : classes.youtubeButton
              }
              onClick={this.changePlatformClick}
            >
              <FontAwesomeIcon className={classes.icon} icon={faYoutube} />
            </StyledButton>
            <Typography variant="body1">YouTube</Typography>
          </Grid>
          <Grid
            container
            align="center"
            justify="center"
            direction="column"
            className={classes.socialSelection}
          >
            <StyledButton name="instagram" className={classes.button} disabled>
              <FontAwesomeIcon className={classes.icon} icon={faInstagram} />
            </StyledButton>
            <Typography variant="body1" display="block">
              Instagram
            </Typography>
            <Box color="text.secondary">
              <Typography className={classes.comingSoon} display="block">
                (coming soon)
              </Typography>
            </Box>
          </Grid>
          <Grid
            container
            align="center"
            justify="center"
            direction="column"
            className={classes.socialSelection}
          >
            <StyledButton name="twitch" className={classes.button} disabled>
              <FontAwesomeIcon className={classes.icon} icon={faTwitch} />
            </StyledButton>
            <Typography variant="body1" display="block">
              Twitch
            </Typography>
            <Box color="text.secondary">
              <Typography className={classes.comingSoon} display="block">
                (coming soon)
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="column">
          <div className={classes.contentTypeTitle}>
            <Typography
              variant="h6"
              align="center"
              error={
                this.state.nextAttempted && this.state.contentTypeError
                  ? true
                  : false
              }
              helperText={
                this.state.nextAttempted ? this.state.contentTypeError : ''
              }
            >
              Content Type
            </Typography>
            {this.state.nextAttempted && this.state.contentTypeError && (
              <Typography align="center" className={classes.inputError}>
                content type is required
              </Typography>
            )}
          </div>
          <Grid
            item
            container
            direction="row"
            className={classes.radioGridContainer}
            spacing={4}
          >
            <Grid
              xs={6}
              sm={4}
              className={classes.contentTypeContainer}
              align="center"
            >
              <Button
                name="review"
                onClick={() => changeContentType(contentTypes.REVIEW)}
                className={`${classes.contentTypeButton} ${
                  campaignInfo.contentType === contentTypes.REVIEW
                    ? classes.selectedContentType
                    : ''
                }`}
              >
                Review
                <HpTooltip
                  styling={{
                    position: 'absolute',
                    right: '8px'
                  }}
                  message={
                    'A video dedicated to revewing their experience with your product or service.'
                  }
                />
              </Button>
            </Grid>
            <Grid
              xs={6}
              sm={4}
              className={classes.contentTypeContainer}
              align="center"
            >
              <Button
                name="gameplay"
                onClick={() => changeContentType(contentTypes.GAMEPLAY)}
                className={`${classes.contentTypeButton} ${
                  campaignInfo.contentType === contentTypes.GAMEPLAY
                    ? classes.selectedContentType
                    : ''
                }`}
              >
                Gameplay
                <HpTooltip
                  styling={{
                    position: 'absolute',
                    right: '8px'
                  }}
                  message={
                    'A video of the content creator playing your game and giving their own positive commentary.'
                  }
                />
              </Button>
            </Grid>
            <Grid
              xs={6}
              sm={4}
              className={classes.contentTypeContainer}
              align="center"
            >
              <Button
                name="mention"
                onClick={() => changeContentType(contentTypes.MENTION)}
                className={`${classes.contentTypeButton} ${
                  campaignInfo.contentType === contentTypes.MENTION
                    ? classes.selectedContentType
                    : ''
                }`}
              >
                Mention
                <HpTooltip
                  styling={{
                    position: 'absolute',
                    right: '8px'
                  }}
                  message={
                    'An endorsement during a video encouraging viewers to use your service, buy your product, or check out your website.'
                  }
                />
              </Button>
            </Grid>
            <Grid
              xs={6}
              sm={4}
              className={classes.contentTypeContainer}
              align="center"
            >
              <Button
                name="tutorial"
                onClick={() => changeContentType(contentTypes.TUTORIAL)}
                className={`${classes.contentTypeButton} ${
                  campaignInfo.contentType === contentTypes.TUTORIAL
                    ? classes.selectedContentType
                    : ''
                }`}
              >
                Tutorial
                <HpTooltip
                  styling={{
                    position: 'absolute',
                    right: '8px'
                  }}
                  message={
                    'A video dedicated to walking viewers through how to use your product or service and why they should buy it.'
                  }
                />
              </Button>
            </Grid>
            <Grid
              xs={6}
              sm={4}
              className={classes.contentTypeContainer}
              align="center"
            >
              <Button
                name="unboxing"
                onClick={() => changeContentType(contentTypes.UNBOXING)}
                className={`${classes.contentTypeButton} ${
                  campaignInfo.contentType === contentTypes.UNBOXING
                    ? classes.selectedContentType
                    : ''
                }`}
              >
                Unboxing
                <HpTooltip
                  styling={{
                    position: 'absolute',
                    right: '8px'
                  }}
                  message={
                    'A video dedicated to the content creator giving a first impression of unpacking your product on camera and why they should buy it.'
                  }
                />
              </Button>
            </Grid>
            <Grid
              xs={6}
              sm={4}
              className={classes.contentTypeContainer}
              align="center"
            >
              <Button
                name="other"
                onClick={() => changeContentType(contentTypes.OTHER)}
                className={`${classes.contentTypeButton} ${
                  campaignInfo.contentType === contentTypes.OTHER
                    ? classes.selectedContentType
                    : ''
                }`}
              >
                Other
                <HpTooltip
                  styling={{
                    position: 'absolute',
                    right: '8px'
                  }}
                  message={
                    "Select this if none of the other options apply. You will manually enter the type of content you'd like to see."
                  }
                />
              </Button>
            </Grid>
            {campaignInfo.contentType === contentTypes.OTHER && (
              <Grid item container direction="column">
                <Typography gutterBottom align="left" display="block">
                  Describe your desired content
                </Typography>
                <TextField
                  id="customContent"
                  name="customContent"
                  variant="outlined"
                  onChange={changeOtherContentDescription}
                  error={
                    this.state.nextAttempted && this.state.otherContentTypeError
                      ? true
                      : false
                  }
                  helperText={
                    this.state.nextAttempted
                      ? this.state.otherContentTypeError
                      : ''
                  }
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.nextButtonClickHandler}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CreatePlatform);



// WEBPACK FOOTER //
// ./src/components/company/campaign/components/CampaignPlatform.js